import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "../i18n"; // make sure your i18n config is correctly set up here
import "./style.css";

const itemsData = (t) => [
  {
    img: "images/img1.jpg",
    title: t("projects1.lualuah3.title"),
    topic: t("topics.underDevelopment"),
    description: t("projects1.lualuah3.projectDescription"),
    detailTitle: t("projects1.lualuah3.detailTitle"),
    detailDescription: t("projects1.lualuah3.detailDescription"),
    specs: [
      { label: t("specs.district"), value: t("specs.values.almAlaz") },
      { label: t("specs.buildings"), value: "30" },
      { label: t("specs.noOfFloors"), value: "3.5" },
      { label: t("specs.buildingArea"), value: "420 m²" },
      { label: t("specs.totalSurfaceArea"), value: "12,600 m²" },
    ],
  },
  {
    img: "images/img2.jpg",
    title: t("projects1.lualuah2.title"),
    topic: t("topics.underDevelopment"),
    description: t("projects1.lualuah2.projectDescription"),
    detailTitle: t("projects1.lualuah2.detailTitle"),
    detailDescription: t("projects1.lualuah2.detailDescription"),
    specs: [
      { label: t("specs.district"), value: t("specs.values.alMurabba") },
      { label: t("specs.units"), value: "107" },
      { label: t("specs.buildingArea"), value: "15,000 m²" },
    ],
  },
  {
    img: "images/img4.jpg",
    title: t("projects1.lualuah1.title"),
    topic: t("topics.underDevelopment"),
    description: t("projects1.lualuah1.projectDescription"),
    detailTitle: t("projects1.lualuah1.detailTitle"),
    detailDescription: t("projects1.lualuah1.detailDescription"),
    specs: [
      { label: t("specs.district"), value: t("specs.values.alMurabba") },
      { label: t("specs.units"), value: "95" },
      { label: t("specs.totalArea"), value: "13,000 m²" },
    ],
  },
  {
    img: "images/img5.jpg",
    title: t("projects1.lualuah5.title"),
    topic: t("topics.futureProject"),
    description: t("projects1.lualuah5.projectDescription"),
    detailTitle: t("projects1.lualuah5.detailTitle"),
    detailDescription: t("projects1.lualuah5.detailDescription"),
    specs: [],
  },
  {
    img: "images/img6.jpg",
    title: t("projects1.lualuah6.title"),
    topic: t("topics.futureProject"),
    description: t("projects1.lualuah6.projectDescription"),
    detailTitle: t("projects1.lualuah6.detailTitle"),
    detailDescription: t("projects1.lualuah6.detailDescription"),
    specs: [],
  },
];

export default function Carousel() {
  const { t } = useTranslation();

  // Initialize items once, on mount, to avoid re-running itemsData on every render
  const [items, setItems] = useState(() => itemsData(t));
  const [animation, setAnimation] = useState("");
  const [showDetail, setShowDetail] = useState(false);
useEffect(() => {
  setItems(itemsData(t));
}, [t]);
  const nextButtonRef = useRef(null);
  const prevButtonRef = useRef(null);
  const timeoutRef = useRef(null);

  // Disable buttons during animation to prevent rapid clicking
  const disableButtonsTemporarily = () => {
    if (nextButtonRef.current) nextButtonRef.current.disabled = true;
    if (prevButtonRef.current) prevButtonRef.current.disabled = true;

    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      if (nextButtonRef.current) nextButtonRef.current.disabled = false;
      if (prevButtonRef.current) prevButtonRef.current.disabled = false;
    }, 700);
  };

  const showSlider = (type) => {
    disableButtonsTemporarily();
    setAnimation(""); // reset animation class

    // Delay the re-arrangement to trigger animation CSS properly
    setTimeout(() => {
      setItems((prevItems) => {
        const newArr = [...prevItems];
        if (type === "next") {
          const first = newArr.shift();
          newArr.push(first);
          setAnimation("next");
        } else {
          const last = newArr.pop();
          newArr.unshift(last);
          setAnimation("prev");
        }
        return newArr;
      });
    }, 20);
  };

  // Close detail view on Escape key press
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape" && showDetail) {
        setShowDetail(false);
      }
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [showDetail]);

  return (
    <div className="carousel-wrapper" >
      <h2 className="carousel-title">{t("ourProjects")}</h2>

      <div className={`carousel ${animation} ${showDetail ? "showDetail" : ""}`}>
        <div className="list">
          {items.map((item, idx) => (
            <div
              key={item.title}
              className="item"
              aria-hidden={idx !== 1}
              aria-label={`${item.title} ${idx === 1 ? t("seeMore") : ""}`}
            >
              <img src={item.img} alt={`${item.title} project`} />
              <div className="introduce">
                <div className="title">{item.title}</div>
                <div className="topic">{item.topic}</div>
                <div className="des">{item.description}</div>
                <button
                  className="seeMore"
                  onClick={() => setShowDetail(true)}
                  aria-label={`${t("seeMore")} ${item.title}`}
                >
                  {t("seeMore")}
                </button>
              </div>

              <div className="detail">
                <div className="title">{item.detailTitle}</div>
                <div className="des">{item.detailDescription}</div>

                <div className="specifications">
                  {(item.specs || []).map((spec, i) => (
                    <div key={i} className="spec-item">
                      <div>
                        <p className="spec-label">{spec.label}</p>
                        <p className="spec-value">{spec.value}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="arrows">
          <button
            id="prev"
            ref={prevButtonRef}
            onClick={() => showSlider("prev")}
            aria-label={t("previousProject", "Previous project")}
          >
            &lt;
          </button>
          <button
            id="next"
            ref={nextButtonRef}
            onClick={() => showSlider("next")}
            aria-label={t("nextProject", "Next project")}
          >
            &gt;
          </button>
          {showDetail && (
            <button
              id="back"
              onClick={() => setShowDetail(false)}
              aria-label={t("seeAll")}
            >
              {t("seeAll")}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
